import type { SVGProps } from "react";
export interface NetworkIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function NetworkIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: NetworkIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M7.481 14.392a1.125 1.125 0 1 1 1.705 1.468L6.06 19.49q.062.245.065.509a2.125 2.125 0 0 1-4.24.218L1.875 20l.01-.217A2.126 2.126 0 0 1 4 17.875l.217.01q.115.012.226.036zm5.473.125a1.125 1.125 0 0 1 1.469.34l.06.096 1.626 2.927A2.123 2.123 0 0 1 16 22.125c-1.1 0-2.006-.836-2.115-1.907l-.01-.218.01-.217c.03-.293.119-.568.255-.813l-1.623-2.924-.051-.103a1.125 1.125 0 0 1 .488-1.426m7.264-4.63a2.125 2.125 0 1 1-2.019 3.238H15a1.125 1.125 0 0 1 0-2.25h3.2c.375-.6 1.04-1 1.8-1l.218.011Zm-16-8.002a2.126 2.126 0 0 1 1.819 2.718l3.139 3.543.072.09a1.126 1.126 0 0 1-1.676 1.483l-.08-.082L4.35 6.092q-.172.03-.35.033c-1.1 0-2.007-.836-2.116-1.908L1.875 4l.01-.218A2.126 2.126 0 0 1 4 1.875l.217.01Zm13 0A2.126 2.126 0 0 1 17 6.125a2 2 0 0 1-.219-.012l-2.508 3.23a1.124 1.124 0 1 1-1.776-1.38l2.51-3.232a2 2 0 0 1-.121-.514L14.876 4l.01-.218A2.126 2.126 0 0 1 17 1.875z"
      />
      <path
        fill={color}
        d="M13.875 12a2.875 2.875 0 1 0-5.75 0 2.875 2.875 0 0 0 5.75 0m2.25 0a5.124 5.124 0 1 1-10.249 0 5.124 5.124 0 0 1 10.248 0Z"
      />
    </svg>
  );
}
